










import Vue from 'vue'
import config from '../../../config'
import { EventBus } from '@/models/event-bus'
import Builder from './Builder.vue'

export default Vue.extend({
   
    created() {
        EventBus.$on('edit-email-template', (templateId: string | undefined, locationId?: string) => {
            if (templateId) {
                this.isModalOpen = true
                this.templateId = templateId
                this.locationId = locationId
            }
        })
    },
    mounted() {
    },
    components: {
        Builder
    },
    data() {
        return {
            locationId: '',
            calendarAppUrl: config.calendarAppUrl,
            isModalOpen: false,
            hasLoadedCalendarApp: false,
            templateId:''
        }
    },
    computed: {
        user() {
            return this.$store.state.user.user
        },
        currentLocationId() {
            return this.locationId || this.$route.params.location_id
        },
        companyId() {
            return this.$store.state.user.user.company_id
        }
    },
    methods: {
        modalClosed() {
            this.isModalOpen = false
            EventBus.$emit('edit-email-template-closed')
        },
    },
})
